import { render, staticRenderFns } from "./completion-record.vue?vue&type=template&id=121a4b9f&scoped=true&"
import script from "./completion-record.vue?vue&type=script&lang=js&"
export * from "./completion-record.vue?vue&type=script&lang=js&"
import style0 from "./completion-record.vue?vue&type=style&index=0&id=121a4b9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a4b9f",
  null
  
)

export default component.exports